import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { ProductPriceType } from '../../interfaces/interfaces';
import { ProductpricetypeeditorComponent } from '../productpricetypeeditor/productpricetypeeditor.component';
import { ProductpricetypedeleteComponent } from '../productpricetypedelete/productpricetypedelete.component';
import { SETTINGS } from 'codefoxhucore';

@Component({
  selector: 'app-productpricetypes',
  templateUrl: './productpricetypes.component.html',
  styleUrls: ['./productpricetypes.component.scss']
})
export class ProductpricetypesComponent extends SimpleTableComponent<ProductPriceType> {

  showProductPriceTypeEditorModal(productPriceType: ProductPriceType|null = null): void {
    this.dialogService.open(ProductpricetypeeditorComponent, {
      header: productPriceType !== null ? 'Termék ár típus szerkesztése - ' + productPriceType.name : 'Termék ár típus hozzáadása',
      data: {
        productPriceTypeId: productPriceType !== null ? productPriceType.id : null
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  showProductPriceTypeDeleteModal(productPriceType: ProductPriceType|null = null): void {
    if (productPriceType === null) {
      return;
    }
    SETTINGS.precheckInterceptorPrecheck = 'ERROR';
    this.apiServiceRef.deleteUserGroup(productPriceType.id).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.dialogService.open(ProductpricetypedeleteComponent, {
        header: 'Termék ár típus törlése - ' + productPriceType.name,
        data: {
          productPriceTypeId: productPriceType.id
        }
      }).onClose.pipe(filter(v => v === true)).subscribe(() => {
        this.refreshTable();
      });
    });
  }

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'productpricetypes';
  }
}
